import { render, staticRenderFns } from "./BrokenNet.vue?vue&type=template&id=9a6f708e&scoped=true&"
import script from "./BrokenNet.vue?vue&type=script&lang=js&"
export * from "./BrokenNet.vue?vue&type=script&lang=js&"
import style0 from "./BrokenNet.vue?vue&type=style&index=0&id=9a6f708e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a6f708e",
  null
  
)

component.options.__file = "BrokenNet.vue"
export default component.exports